import { type FC, type PropsWithChildren, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {
    RouterContext,
    type RouterContextType,
    type UIContextType,
    UIProvider,
} from "@onshopfront/components";

const FLOATING_ROOT = "floating-root-container";

const uiContext: Partial<UIContextType> = {
    rootId: FLOATING_ROOT,
};

export const DeveloperUIContainer: FC<PropsWithChildren> = ({ children }) => {
    const navigate = useNavigate();

    const routerContext = useMemo<RouterContextType>(() => ({
        type: "normal",
        navigate,
    }), [ navigate ]);

    return (
        <RouterContext value={routerContext}>
            <UIProvider value={uiContext}>
                {children}
                <div
                    id={FLOATING_ROOT}
                    className="pointer-events-none absolute inset-0 overflow-hidden"
                />
            </UIProvider>
        </RouterContext>
    );
};
